import { render, staticRenderFns } from "./NoSiteFound.vue?vue&type=template&id=58af3b2a&scoped=true"
import script from "./NoSiteFound.vue?vue&type=script&lang=js"
export * from "./NoSiteFound.vue?vue&type=script&lang=js"
import style0 from "./NoSiteFound.vue?vue&type=style&index=0&id=58af3b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af3b2a",
  null
  
)

export default component.exports